export class OptionService {
  constructor() {
    this.cache = {};
  }

  reset() {
    this.cache = {};
  }

  async getCache(name, promise) {
    return new Promise(resolve => {
      if (this.cache.hasOwnProperty(name)) {
        resolve(this.cache[name]);
      } else {
        promise.then(resolve).catch(() => resolve([]));
      }
    });
  }
}
